<template>
    <div class="announcePart">
        <ul>
            <li @click="toDetail(item)" v-for="(item,index) in list" :key="index" >
                <img :src= "item.coverLink" >
                <p class="title">{{item.title}}</p>
                <p class="date" >{{item.createTime}}</p>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    data(){
        return{
            list: []
        }
    },
    mounted(){
        let that = this;
        that.postRequest('/capp-notice/notice/we/chat/open/findNoticeWx',{
            //  appId : 'wxe7bb99f7923d250c',
        appId : sessionStorage.getItem('appId'),
        username : sessionStorage.getItem('userName')
        },function(data){
            console.log(data)
            that.list = data.datas
        },'n')
    },
    methods:{
        toDetail(item){
            this.$router.push({
                  name: 'announceDetail',
                  params: {
                    noticeId: item.id
                  }
                })
        }
    }
}
</script>
<style scoped>
.announcePart ul li{
    width: 92%;
    margin: .35rem auto;
    text-align: left;
    border-radius: .1rem;
    box-shadow:0px 9px 19px 1px rgba(208,208,208,0.33);
}
.announcePart ul li img{
    width: 100%;
    height: 4rem;
}
.announcePart ul li p{
    margin: .2rem  0 0 .4rem ;
}
.announcePart ul li .title{
    font-size: .5rem;
}
.announcePart ul li .date{
    color:#999;
    padding-bottom: .3rem;
    box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/components/mingsheng/announce.vue